/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { DocCenterService } from "../services/docCenterService.js";
import { FileService } from "../services/fileService.js";
import { CmsService } from "../services/cmsService.js";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SweetAlertService from "../services/SweetAlertService";
import functionConstants from "../utils/functionConstants.js";

const ViewDocForm = (props) => {
  const functionList = String(localStorage.getItem("functionId")).split(",");
  // eslint-disable-next-line no-unused-vars
  const [savedLanguage, setSaveLanguage] = useState();
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const { t, i18n } = useTranslation();
  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);
  const [IFACA, setIFACA] = useState(props.documentCenterList.ifaCaIndicator);
  const [values, setValues] = useState({
    titleEnglish: props.documentCenterList.titleEng,
    titleTraditionalChinese: props.documentCenterList.titleHk,
    titleSimplifiedChinese:
      props.documentCenterList.titleCn === null
        ? ""
        : props.documentCenterList.titleCn,
    descriptionEnglish: props.documentCenterList.descriptionEng,
    descriptionTraditionalChinese: props.documentCenterList.descriptionHk,
    descriptionSimplifiedChinese:
      props.documentCenterList.descriptionCn === null
        ? ""
        : props.documentCenterList.descriptionCn,
    effectiveDateFrom: props.documentCenterList.effectiveDateFrom.slice(0, 10),
    effectiveDateTo: props.documentCenterList.effectiveDateTo.slice(0, 10),
  });
  const [isPin, setIsPin] = useState(
    props.documentCenterList.isPin === "Y" ? true : false
  );
  const [isPromo, setIsPromo] = useState(
    props.documentCenterList.isPromo === "Y" ? true : false
  );
  const [fileId1, setFileId1] = useState(props.documentCenterList.file1Id);
  const [fileId2, setFileId2] = useState(props.documentCenterList.file2Id);
  const [fileId3, setFileId3] = useState(props.documentCenterList.file3Id);
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [fileName3, setFileName3] = useState("");
  const [base1, setBase1] = useState("");
  const [base2, setBase2] = useState("");
  const [base3, setBase3] = useState("");
  const [selected, setSelected] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState(
    props.documentCenterList.mainCategoryId
  );
  const [selectedSubCategory, setSelectedSubCategory] = useState(
    props.documentCenterList.subCategoryId
  );

  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    const loadingSwal = SweetAlertService.showLoading(t("common.loading"));

    const docCenterService = new DocCenterService();
    const fileService = new FileService();

    const visibilityPromise = functionList.includes(
      String(functionConstants.DOCUMENT_CENTER_VISIBILITY)
    )
      ? docCenterService.retrieveVisibility(
          props.documentCenterList.documentCenterId
        )
      : Promise.resolve([]); // Return an empty array if visibility check is not required

    const file1Promise = fileService.download(props.documentCenterList.file1Id);
    const file2Promise = props.documentCenterList.file2Id
      ? fileService.download(props.documentCenterList.file2Id)
      : null;
    const file3Promise = props.documentCenterList.file3Id
      ? fileService.download(props.documentCenterList.file3Id)
      : null;

    Promise.all([visibilityPromise, file1Promise, file2Promise, file3Promise])
      .then((values) => {
        let brokerListPromise = null;
        let agentCodes = null;
        if (
          functionList.includes(
            String(functionConstants.DOCUMENT_CENTER_VISIBILITY)
          )
        ) {
          const visibilityData = values[0].data;
          agentCodes = visibilityData.map((agent) => agent.agentCode);
          brokerListPromise = docCenterService.retrieveBrokerList();
        }

        const file1Data = values[1].data;
        const file2Data = values[2] ? values[2].data : null;
        const file3Data = values[3] ? values[3].data : null;

        return Promise.all([
          brokerListPromise,
          file1Data,
          file2Data,
          file3Data,
          agentCodes,
        ]);
      })
      .then((values) => {
        if (
          functionList.includes(
            String(functionConstants.DOCUMENT_CENTER_VISIBILITY)
          )
        ) {
          const brokerList = values[0].data;
          const agentCodes = values[4];
          const filteredBrokerCodes = brokerList.filter((broker) =>
            agentCodes.includes(broker.brokerCode)
          );

          const formattedSelect = filteredBrokerCodes.map((broker) => ({
            label: `${broker.brokerName} (${broker.brokerCode})`,
            value: broker.brokerCode,
          }));

          setSelected(formattedSelect);
        }

        const file1Data = values[1];
        const file2Data = values[2];
        const file3Data = values[3];

        setFileName1(file1Data.documentName);
        setBase1(file1Data.documentBase64String);

        if (file2Data) {
          setFileName2(file2Data.documentName);
          setBase2(file2Data.documentBase64String);
        }

        if (file3Data) {
          setFileName3(file3Data.documentName);
          setBase3(file3Data.documentBase64String);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        SweetAlertService.close(loadingSwal);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadFile = (number) => {
    if (number === 1) {
      download(fileName1, base1);
    }

    if (number === 2) {
      download(fileName2, base2);
    }

    if (number === 3) {
      download(fileName3, base3);
    }
  };

  const download = (name, base) => {
    const fileExtension = name.split(".").pop().toLowerCase();
    let fileType = "";
    switch (fileExtension) {
      case "csv":
        fileType = "text/csv";
        break;
      case "doc":
        fileType = "application/msword";
        break;
      case "docx":
        fileType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      case "ppt":
        fileType = "application/vnd.ms-powerpoint";
        break;
      case "pptx":
        fileType =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        break;
      case "xls":
        fileType = "application/vnd.ms-excel";
        break;
      case "xlsx":
        fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "pdf":
        fileType = "application/pdf";
        break;
      case "png":
        fileType = "image/png";
        break;
      case "jpeg":
      case "jpg":
        fileType = "image/jpeg";
        break;
      case "gif":
        fileType = "image/gif";
        break;
      default:
        fileType = "application/octet-stream";
        break;
    }

    const decodedFile = window.atob(base);
    const byteArray = new Uint8Array(decodedFile.length);
    for (let i = 0; i < decodedFile.length; ++i) {
      byteArray[i] = decodedFile.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: fileType });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleIFACAChange = (event) => {
    setIFACA(event.target.value);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues({ ...values, [name]: value });
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    if (
      values.campaignNameZHCN === undefined ||
      values.campaignNameZHCN === null
    ) {
      values.campaignNameZHCN = "";
    }

    if (values.thumbnailDocID === undefined || values.thumbnailDocID === null) {
      values.thumbnailDocID = "";
    }

    if (values.remark === undefined || values.remark === null) {
      values.remark = "";
    }

    if (values.file === undefined || values.file === null) {
      values.file = "";
    }

    e.preventDefault();
    var docService = new DocCenterService();

    try {
      docService
        .createDocCenter(
          props.documentCenterList.documentCenterId,
          "edit",
          values,
          selectedMainCategory,
          selectedSubCategory,
          fileId1,
          fileId2,
          fileId3,
          isPin,
          isPromo,
          IFACA,
          selected
        )
        .then((value) => {
          if (value.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Document Updated",
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/DocCenter";
            });
          }
        });
    } catch (error) {}
  };

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
    };
  }, []);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveCategoryList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setMainCategories(data.firstLevelCategoryList);
      });
  }, []);

  const handleMainCategoryChange = (event) => {
    const selectedMainCategoryId = event.target.value;
    setSelectedMainCategory(selectedMainCategoryId);
    setSelectedSubCategory(0);
  };

  const handleSubCategoryChange = (event) => {
    const selectedSubCategoryId = event.target.value;
    setSelectedSubCategory(selectedSubCategoryId);
  };

  const subCategoryOptions = selectedMainCategory
    ? mainCategories.find(
        (category) =>
          String(category.categoryId) === String(selectedMainCategory)
      )?.secondLevelCategoryList
    : null;

  return (
    <>
      {isMobileScreen ? (
        <>
          <div>
            <form
              className="border border-red rounded text-mobileLandingContent"
              onSubmit={handleSubmit}>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="titleEnglish">
                    {t("documentCenterPage.titleEng")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleEnglish"
                    name="titleEnglish"
                    value={values.titleEnglish}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="titleTraditionalChinese">
                    {t("documentCenterPage.titleHk")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleTraditionalChinese"
                    name="titleTraditionalChinese"
                    value={values.titleTraditionalChinese}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="titleSimplifiedChinese">
                    {t("documentCenterPage.titleCn")}
                  </label>
                  <input
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleSimplifiedChinese"
                    name="titleSimplifiedChinese"
                    value={values.titleSimplifiedChinese}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="IFA/CA">
                    {t("common.ifaCa")}
                    <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="IFACA"
                    aria-label="Select IFA/CA"
                    className="bg-gray-200 w-full bg-white-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                    value={IFACA}
                    name="ifaCaIndicator"
                    onChange={handleIFACAChange}
                    disabled>
                    <option value="IFA&CA">{t("common.ifaAndCa")}</option>
                    <option value="IFA">{t("common.ifa")}</option>
                    <option value="CA">{t("common.ca")}</option>
                  </select>
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="effectiveDateFrom">
                    {t("common.startDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateFrom"
                    name="effectiveDateFrom"
                    value={values.effectiveDateFrom}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="effectiveDateTo">
                    {t("common.endDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateTo"
                    name="effectiveDateTo"
                    value={values.effectiveDateTo}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label>
                    {t("cms.mainCategory")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <br></br>
                  <select
                    disabled
                    value={selectedMainCategory}
                    onChange={handleMainCategoryChange}
                    className="rounded border bg-gray-200 border-red-400 h-10 w-full">
                    <option value="" className="text-ft">
                      {t("cms.select") + t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}>
                        {savedLanguage === "en"
                          ? category.categoryNameEng
                          : savedLanguage === "cn"
                          ? category.categoryNameCn
                          : category.categoryNameHk}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {subCategoryOptions && (
                <div className="form-row flex mx-3 my-4">
                  <div className="px-4 w-full">
                    <label>{t("cms.subCategory")}:</label>
                    <br></br>
                    <select
                      disabled
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                      className="rounded border bg-gray-200 border-red-300 h-10 w-full">
                      <option value="">
                        {t("cms.select") + t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {savedLanguage === "en"
                            ? subCategory.categoryNameEng
                            : savedLanguage === "cn"
                            ? subCategory.categoryNameCn
                            : subCategory.categoryNameHk}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="descriptionEnglish">
                    {t("documentCenterPage.descriptionEng")}
                    <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionEnglish"
                    name="descriptionEnglish"
                    value={values.descriptionEnglish}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="descriptionTraditionalChinese">
                    {t("documentCenterPage.descriptionHk")}
                    <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionTraditionalChinese"
                    name="descriptionTraditionalChinese"
                    value={values.descriptionTraditionalChinese}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>

              <div className="form-row flex mx-3 my-4">
                <div className="px-4 w-full">
                  <label htmlFor="descriptionSimplifiedChinese">
                    {t("documentCenterPage.descriptionCn")}
                  </label>
                  <textarea
                    type="text"
                    className="form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="descriptionSimplifiedChinese"
                    name="descriptionSimplifiedChinese"
                    value={values.descriptionSimplifiedChinese}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-4 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (1)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    {fileId1 !== 0 ? (
                      <a
                        className="cursor-pointer	 text-ft-light hover:text-ft"
                        onClick={() => downloadFile(1)}>
                        {" "}
                        {fileName1}
                      </a>
                    ) : (
                      "No uploaded file"
                    )}
                  </p>
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-4 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (2)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    <a
                      className="cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(2)}>
                      {" "}
                      {fileName2}
                    </a>
                  </p>
                </div>
              </div>

              <div className="form-row flex m-3">
                <div className="px-4 w-full">
                  <p className="text-landingHeader font-bold">
                    {t("common.file")} (3)
                  </p>
                  <p className="text-mobileLandingContent">
                    {t("common.currentFile")}:{" "}
                    <a
                      className="cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(3)}>
                      {" "}
                      {fileName3}{" "}
                    </a>
                  </p>
                </div>
              </div>

              <div className="px-6 py-4 flex justify-end">
                <button
                  onClick={() => navigate(-1)}
                  type="button"
                  className="ml-4 text-ft-light ring-1 ring-ft-light bg-white hover:bg-ft hover:text-white rounded-md px-4 py-2 active:bg-white active:text-red-500 active:ring-1 active:ring-red-500 transition">
                  {t("common.back")}
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <div>
          <form
            className="border border-red rounded p-1 text-content"
            onSubmit={handleSubmit}>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleEnglish">
                    {t("documentCenterPage.titleEng")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleEnglish"
                    name="titleEnglish"
                    value={values.titleEnglish}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleTraditionalChinese">
                    {t("documentCenterPage.titleHk")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleTraditionalChinese"
                    name="titleTraditionalChinese"
                    value={values.titleTraditionalChinese}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="titleSimplifiedChinese">
                    {t("documentCenterPage.titleCn")}
                  </label>
                  <input
                    type="text"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="titleSimplifiedChinese"
                    name="titleSimplifiedChinese"
                    value={values.titleSimplifiedChinese}
                    onChange={handleChange}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="IFA/CA">
                    {t("common.ifaCa")}
                    <span className="text-red-600">*</span>
                  </label>
                  <select
                    id="IFACA"
                    aria-label="Select IFA/CA"
                    className="w-full border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                    style={{ backgroundColor: "#e9ecef" }}
                    value={IFACA}
                    name="ifaCaIndicator"
                    onChange={handleIFACAChange}
                    disabled>
                    <option value="IFA&CA">{t("common.ifaAndCa")}</option>
                    <option value="IFA">{t("common.ifa")}</option>
                    <option value="CA">{t("common.ca")}</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="effectiveDateFrom">
                    {t("common.startDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateFrom"
                    name="effectiveDateFrom"
                    value={values.effectiveDateFrom}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
              <div className="form-group w-1/2 flex justify-center">
                <div className="w-11/12">
                  <label htmlFor="effectiveDateTo">
                    {t("common.endDate")}
                    <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                    id="effectiveDateTo"
                    name="effectiveDateTo"
                    value={values.effectiveDateTo}
                    onChange={handleChange}
                    required
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="form-group w-full ml-6 flex ">
                <div className="mt-2 w-1/2 mr-9">
                  <label>
                    {t("cms.mainCategory")}:
                    <span className="text-red-600">*</span>
                  </label>
                  <br></br>
                  <select
                    style={{ backgroundColor: "#e9ecef" }}
                    value={selectedMainCategory}
                    onChange={handleMainCategoryChange}
                    className="rounded border  border-red-400 h-10 w-full"
                    disabled>
                    <option value="" className="text-ft">
                      {t("cms.select") + t("cms.mainCategory")}
                    </option>
                    {mainCategories.map((category) => (
                      <option
                        key={category.categoryId}
                        value={category.categoryId}>
                        {category.categoryNameEng}
                      </option>
                    ))}
                  </select>
                </div>

                {subCategoryOptions && (
                  <div className="mt-2 w-1/2 mr-5">
                    <label>{t("cms.subCategory")}:</label>
                    <br></br>
                    <select
                      style={{ backgroundColor: "#e9ecef" }}
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                      className="rounded border  border-red-300 h-10 w-full"
                      disabled>
                      <option value="">
                        {t("cms.select") + t("cms.subCategory")}
                      </option>
                      {subCategoryOptions.map((subCategory) => (
                        <option
                          key={subCategory.categoryId}
                          value={subCategory.categoryId}>
                          {subCategory.categoryNameEng}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionEnglish">
                  {t("documentCenterPage.descriptionEng")}
                  <span className="text-red-600">*</span>
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionEnglish"
                  name="descriptionEnglish"
                  value={values.descriptionEnglish}
                  onChange={handleChange}
                  required
                  disabled
                />
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionTraditionalChinese">
                  {t("documentCenterPage.descriptionHk")}
                  <span className="text-red-600">*</span>
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionTraditionalChinese"
                  name="descriptionTraditionalChinese"
                  value={values.descriptionTraditionalChinese}
                  onChange={handleChange}
                  required
                  disabled
                />
              </div>
            </div>
            <div className="form-row flex mx-3 my-5">
              <div className="px-4 w-full">
                <label htmlFor="descriptionSimplifiedChinese">
                  {t("documentCenterPage.descriptionCn")}
                </label>
                <textarea
                  type="text"
                  className="text-content form-control ring-0 hover:border-ft-light active:border-ft-light focus:border-ft-light"
                  id="descriptionSimplifiedChinese"
                  name="descriptionSimplifiedChinese"
                  value={values.descriptionSimplifiedChinese}
                  onChange={handleChange}
                  disabled
                />
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (1)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  {fileId1 !== 0 ? (
                    <a
                      className="cursor-pointer	 text-ft-light hover:text-ft"
                      onClick={() => downloadFile(1)}>
                      {" "}
                      {fileName1}
                    </a>
                  ) : (
                    "No uploaded file"
                  )}
                </p>
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (2)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  <a
                    className="cursor-pointer	 text-ft-light hover:text-ft"
                    onClick={() => downloadFile(2)}>
                    {" "}
                    {fileName2}
                  </a>
                </p>
              </div>
            </div>
            <div className="form-row flex m-3">
              <div className="px-4 w-full">
                <p className="text-landingHeader font-bold">
                  {t("common.file")} (3)
                </p>
                <p className="text-content">
                  {t("common.currentFile")}:{" "}
                  <a
                    className="cursor-pointer	 text-ft-light hover:text-ft"
                    onClick={() => downloadFile(3)}>
                    {" "}
                    {fileName3}{" "}
                  </a>
                </p>
              </div>
            </div>

            <div className="px-6 py-4 flex justify-end">
              <button
                onClick={() => navigate(-1)}
                type="button"
                className="ml-4 text-ft-light ring-1 ring-ft-light bg-white hover:bg-ft hover:text-white rounded-md px-4 py-2  transition">
                {t("common.back")}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default ViewDocForm;
